import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import VirtualCardReadyPage from './VirtualCardReadyPage';

const VirtualCardReadyRoute: FuseRouteItemType = {
  path: 'virtual-card-ready',
  element: <VirtualCardReadyPage />,
  auth: AUTH_ROLES.parent,
};

export default VirtualCardReadyRoute;
